module.exports = __webpack_public_path__ + "static/img/black_out.5c08f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/black_out.jpg
// module id = S08u
// module chunks = 1